import { render, staticRenderFns } from "./DutyDoc.vue?vue&type=template&id=cfa32144&scoped=true"
import script from "./DutyDoc.vue?vue&type=script&lang=js"
export * from "./DutyDoc.vue?vue&type=script&lang=js"
import style0 from "./DutyDoc.vue?vue&type=style&index=0&id=cfa32144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa32144",
  null
  
)

export default component.exports